import { styled, SxProp, useSx } from 'dripsy';
import React from 'react';
import { StyleProp, View, ViewProps, ViewStyle } from 'react-native';

const Cover = styled(View)({
  position: 'absolute',
  width: '100%',
  height: '100%',
});

export interface ICoverViewProps extends ViewProps {
  isVisible: boolean;
  children: React.ReactChild;
  CoverComponent: React.FunctionComponent;
  coverComponentStyles?: StyleProp<ViewStyle>;
  coverComponentSx?: SxProp;
}

export function CoverView({
  children,
  CoverComponent,
  isVisible,
  coverComponentStyles,
  coverComponentSx,
  ...props
}: ICoverViewProps) {
  const sx = useSx();

  const coverSx = coverComponentSx && sx(coverComponentSx);
  const coverStyles =
    coverComponentStyles && coverSx
      ? [coverComponentStyles, coverSx]
      : coverSx || coverComponentStyles;

  return (
    <View {...props}>
      {children}
      {isVisible && (
        <Cover style={coverStyles}>
          <CoverComponent />
        </Cover>
      )}
    </View>
  );
}
